//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';

import { ICuralateStore } from '@models/AppState';
import { IActionCreatorMap } from '@utils/types/ActionCreators';

/**
 * Prefer use of useDispatch from 'react-redux'
 * Bound action creators is an anti-pattern
 *
 * @deprecated
 */
export function useBoundActionCreators<T extends IActionCreatorMap>(
  actionCreators: T,
) {
  const reduxDispatch = useDispatch();
  return bindActionCreators<T>(actionCreators, reduxDispatch);
}

/**
 * Prefer use of useSelector from 'react-redux'
 * `useSelector` can directly replace usage of `useTypedSelector`
 *
 * @deprecated
 */
export const useTypedSelector: TypedUseSelectorHook<ICuralateStore> =
  useSelector;
